import { Platform } from 'react-native';

// Central font mapping for the entire app.
// Android resolves by file name, iOS by PostScript name.
// This is the single source of truth for all fonts used in the app.

// GT Walsheim fonts
// WEB: do NOT add a `web:` key here. RNW Platform.select prefers `web` over `default`.
// injectAppFontsWeb registers @font-face under these `default` family names
// (GT-Walsheim-Regular, etc). A web override (e.g. Segoe UI / Arial) never
// matches those faces — fonts silently fall back to system sans.
export const GTFonts = {
  regular: Platform.select({
    ios: 'GTWalsheimTrial-Rg',
    android: 'GT-Walsheim-Regular',
    default: 'GT-Walsheim-Regular',
  }) as string,
  semibold: Platform.select({
    ios: 'GTWalsheimTrial-CnMd',
    android: 'GT-Walsheim-SemiBold',
    default: 'GT-Walsheim-SemiBold',
  }) as string,
  bold: Platform.select({
    ios: 'GTWalsheimTrial-CnBd',
    android: 'GT-Walsheim-Bold',
    default: 'GT-Walsheim-Bold',
  }) as string,
  thin: Platform.select({
    ios: 'GTWalsheimTrial-Th',
    android: 'GT-Walsheim-Thin',
    default: 'GT-Walsheim-Thin',
  }) as string,
};

// Poppins fonts
export const PoppinsFonts = {
  regular: Platform.select({
    ios: 'Poppins-Regular',
    android: 'Poppins-Regular',
    default: 'Poppins-Regular',
  }) as string,
  semibold: Platform.select({
    ios: 'Poppins-SemiBold',
    android: 'Poppins-SemiBold',
    default: 'Poppins-SemiBold',
  }) as string,
  bold: Platform.select({
    ios: 'Poppins-Bold',
    android: 'Poppins-Bold',
    default: 'Poppins-Bold',
  }) as string,
  // Base family name (falls back to Regular)
  base: Platform.select({
    ios: 'Poppins',
    android: 'Poppins',
    default: 'Poppins',
  }) as string,
};

// Lato fonts
export const LatoFonts = {
  regular: Platform.select({
    ios: 'Lato-Regular',
    android: 'Lato-Regular',
    default: 'Lato-Regular',
  }) as string,
  // Base family name (falls back to Regular)
  base: Platform.select({
    ios: 'Lato',
    android: 'Lato',
    default: 'Lato',
  }) as string,
};
